module.exports = __webpack_public_path__ + "static/media/mohtwize.4f9efb4c.webp";